import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsKitQuanrantineReasonServices = {
  //Quanrantine Reason
  addNewEIWRSKitQuanrantineReason,
  updateEIWRSKitQuanrantineReasonData,
  deleteEIWRSKitQuanrantineReasonData,
  softDeleteRestoreEIWRSKitQuanrantineReason,
  getEIWRSKitQuanrantineReasonData,
};

// Add New Kit Quanrantine Reason
async function addNewEIWRSKitQuanrantineReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSKitQuanrantineReason`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Kit Quanrantine Reason
async function updateEIWRSKitQuanrantineReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSKitQuanrantineReasonData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Kit Quanrantine Reason
async function softDeleteRestoreEIWRSKitQuanrantineReason(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSKitQuanrantineReason`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Kit Quanrantine Reason
async function deleteEIWRSKitQuanrantineReasonData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSKitQuanrantineReasonData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Kit Quanrantine Reason
async function getEIWRSKitQuanrantineReasonData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitQuanrantineReasonData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitQuanrantineReasonData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}